module.exports = __webpack_public_path__ + "static/media/Anim_esp.b942f3b5.fbx";